import { ChevronDown } from "lucide-react";
import useTranslations from "@/shared/lang/useTranslations";

type AccountsWalletsShowMoreProps = {
  onShowMore?: () => void;
  isLoadingMore?: boolean;
};

export const AccountsWalletsShowMore = ({
  onShowMore,
  isLoadingMore = false,
}: AccountsWalletsShowMoreProps) => {
  const { t } = useTranslations("accountsWallets");
  return (
    <div className="flex flex-col items-center justify-center pt-8 pb-16">
      {onShowMore && (
        <button
          type="button"
          onClick={onShowMore}
          disabled={isLoadingMore}
          className="group flex items-center gap-2 text-green-500 dark:text-green-400 font-bold hover:text-green-600 dark:hover:text-green-300 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span>{t("show_more")}</span>
          <ChevronDown className="h-5 w-5 group-hover:translate-y-0.5 transition-transform" />
        </button>
      )}
    </div>
  );
};
